import { Meta } from '../../../graphql/graphql';
import { MetaKey } from '../Enums/MetaKey.enum';

export const findInMeta = ({
	meta,
	metaKey,
}: {
	meta: Meta[];
	metaKey: MetaKey;
}) => {
	return meta?.find(({ key }: any) => key === metaKey);
};
